import React from "react";
import { useSettings } from "@/context/SettingsContext";
import { MessageCircle, MapPin, Clock } from "lucide-react";

export default function Contact() {
  const { settings } = useSettings();
  const number = settings?.whatsapp_number || "2250711693161";

  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-16 lg:py-28">
      <div className="label-tiny mb-3 flex items-center gap-3">
        <span className="gold-line" /> Nous Contacter
      </div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight mb-12">
        Restons en <span className="text-[#B8860B]">communion</span>
      </h1>

      <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
        <div className="border border-black/5 bg-white p-8" data-testid="contact-whatsapp">
          <MessageCircle size={28} strokeWidth={1.25} className="text-[#B8860B]" />
          <div className="label-tiny mt-4">WhatsApp</div>
          <a
            href={`https://wa.me/${number}`}
            target="_blank"
            rel="noopener noreferrer"
            className="block mt-2 text-[#1A1A1A] hover:text-[#B8860B] font-display text-lg"
          >
            +225 07 11 69 31 61
          </a>
        </div>

        <div className="border border-black/5 bg-white p-8">
          <MapPin size={28} strokeWidth={1.25} className="text-[#B8860B]" />
          <div className="label-tiny mt-4">Localisation</div>
          <p className="mt-2 text-[#1A1A1A] font-display text-lg">Abidjan</p>
          <p className="mt-2 text-sm text-[#6B6B6B] mt-1">{`Côte d'Ivoire`}</p>
        </div>

        <div className="border border-black/5 bg-white p-8">
          <Clock size={28} strokeWidth={1.25} className="text-[#B8860B]" />
          <div className="label-tiny mt-4">Livraison</div>
          <p className="mt-2 text-[#1A1A1A] font-display text-lg">Sous 24h</p>
          <p className="text-sm text-[#6B6B6B] mt-1">à Abidjan</p>
        </div>
      </div>

      <div className="mt-16 border border-[#B8860B]/30 p-10 text-center">
        <p className="font-citation italic text-lg lg:text-xl text-[#1A1A1A]/85 leading-relaxed max-w-2xl mx-auto">
          {`"Demandez, et l'on vous donnera ; cherchez, et vous trouverez ; frappez, et l'on vous ouvrira."`}
        </p>
        <p className="mt-4 text-xs tracking-[0.3em] uppercase text-[#B8860B]">— Matthieu 7:7</p>
      </div>
    </div>
  );
}
